import Navigation from "../components/Navigation";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Subscription from "../components/Subscription";
gsap.registerPlugin(ScrollTrigger);

export default class Common {
  constructor() {
    const navDOM = document.querySelector("nav");
    this.nav = new Navigation(navDOM);

    const subForms = document.querySelectorAll("[js-subscription-email]");
    for (let subForm of subForms) {
      let subscription = new Subscription(subForm);
      subscription.init();
    }
  }

  init() {
    this.nav.init();
    this.initStElements();
    this.initBackToTop();

    const expandableDOMs = document.querySelectorAll(".expandable-content");
    for (let dom of expandableDOMs) {
      const wrapper = dom.querySelector(".expand-wrapper");
      const btn = dom.querySelector(".btn-read-more");
      btn.addEventListener("pointerup", () => {
        wrapper.classList.add("expanded");
        btn.classList.add("clicked");
      });
    }

    const downloadBtns = document.querySelectorAll("a.btn-cta[download]");
    for (let btn of downloadBtns) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        let url = btn.getAttribute("href");
        let mediaType = btn.getAttribute("data-type");
        this.handleDownload(url, mediaType);
      });
    }
  }

  async handleDownload(url, mediaType) {
    let extension = ".mp4";
    switch (mediaType) {
      case "video":
        extension = ".mp4";
        break;
      case "img":
        extension = ".jpg";
        break;
    }
    let filename = `fabrix-ar-fiting${extension}`;

    if (navigator.canShare) {
      const blob = await fetch(url).then((r) => r.blob());

      navigator
        .share({
          files: [
            new File([blob], filename, {
              type: blob.type,
            }),
          ],
        })
        .then(() => console.log("Share was successful."))
        .catch((error) => console.log("Sharing failed", error));
    } else {
      let link = document.createElement("a");
      link.setAttribute("download", "");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  initStElements() {
    gsap.registerPlugin(ScrollTrigger);

    let textWrapperTargets = gsap.utils.toArray(`[js-reveal]`, document);
    textWrapperTargets.forEach((target) => {
      gsap.from(target, {
        duration: 0.3,
        opacity: 0,
        y: 50,
        ease: "none",
        stagger: 0.2,
        scrollTrigger: {
          trigger: target,
          markers: false,
          start: "top bottom",
          end: "bottom 90%",
          scrub: true,
        },
      });
    });
  }

  initBackToTop() {
    const btns = document.querySelectorAll(".btn-btt");
    for (let btn of btns) {
      btn.addEventListener("pointerup", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  }
}
